import React from "react";

const ConfirmCheckbox = ({
  id,
  condition = true,
  label,
  confirmText = "Eminim",
  confirmed,
  onChange,
  disabled = false,
}) => {
  if (!condition) return null;

  return (
    <div
      style={{
        marginTop: "16px",
        padding: "10px",
        borderTop: "1px solid #e5e7eb",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <label
        htmlFor={id}
        style={{
          display: "block",
          marginBottom: "8px",
          fontSize: "15px",
          fontWeight: 500,
          color: "#374151",
        }}
      >
        {label}
      </label>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <input
          type="checkbox"
          id={id}
          checked={confirmed}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          style={{
            transform: "scale(1.4)",
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        />
        <label
          htmlFor={id}
          style={{
            fontSize: "15px",
            userSelect: "none",
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          {confirmText}
        </label>
      </div>
    </div>
  );
};

export default ConfirmCheckbox;
